import { getIndicatorPlacement } from "./indicators";
import { plotHeight } from "./state";
import type { State } from "./types";

const MAX_RENDERED_PANEL_INDICATORS = 2;

export type ChartLayout = {
  plotBottom: number;
  hasPanelIndicators: boolean;
  timeAxisBand: number;
  panelGap: number;
  mainPlotBottom: number;
  timeAxisTop: number;
  timeAxisBottom: number;
  panelTop: number;
  panelBottom: number;
  timeLabelY: number;
  mainState: State;
};

export function getChartLayout(state: State): ChartLayout {
  const panelCount = state.indicators
    .filter((indicator) => getIndicatorPlacement(indicator.type) === "panel")
    .slice(0, MAX_RENDERED_PANEL_INDICATORS).length;
  const hasPanelIndicators = panelCount > 0;
  const plotBottom = state.top + plotHeight(state);
  const timeAxisBand = hasPanelIndicators ? 30 : state.bottom;
  const panelGap = hasPanelIndicators ? 2 : 0;
  const mainHeightRatio = panelCount > 1 ? 0.60 : 0.72;
  const mainPlotBottom = hasPanelIndicators ? state.top + plotHeight(state) * mainHeightRatio : plotBottom;
  const timeAxisTop = mainPlotBottom;
  const timeAxisBottom = hasPanelIndicators ? mainPlotBottom + timeAxisBand : state.height - state.bottom;
  const panelTop = timeAxisBottom + panelGap;
  const panelBottom = plotBottom;
  const timeLabelY = hasPanelIndicators ? timeAxisTop + 8 : state.height - state.bottom + 6;
  const mainState: State = {
    ...state,
    bottom: state.height - mainPlotBottom,
  };

  return {
    plotBottom,
    hasPanelIndicators,
    timeAxisBand,
    panelGap,
    mainPlotBottom,
    timeAxisTop,
    timeAxisBottom,
    panelTop,
    panelBottom,
    timeLabelY,
    mainState,
  };
}
